import { render } from "./NotificationPopUp.vue?vue&type=template&id=10f44c00&scoped=true"
import script from "./NotificationPopUp.vue?vue&type=script&lang=js"
export * from "./NotificationPopUp.vue?vue&type=script&lang=js"

import "./NotificationPopUp.vue?vue&type=style&index=0&id=10f44c00&scoped=true&lang=css"

import exportComponent from "/Users/mattia/Desktop/Projects/elbi-website-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10f44c00"]])

export default __exports__